export enum ZusContribution {
    Self = 'Self',
    SelfAndEmployees = 'SelfAndEmployees'
}
